 const config={
    endPoint:'https://backend-windows.360softsolutionsapp.com/SiscomerBaumWeb/',    
    // endPoint:'https://backend-siscomer-operaciones-comerciales.360softsolutionsapp.com/',                 
    // endPoint:'https://backend-siscomer-operaciones-web.360softsolutionsapp.com/',
    // endPoint:'https://backend-siscomer-baum-web.360softsolutionsapp.com/',
    // endPoint:'backend-siscomer-baum.360softsolutionsapp.com',

    splitFileRows:500,
    ApiKeyAmazon:'',
    storageName:'siscomer-webtoken',
    storageDateName:'siscomer-datetime-program',
    storageDateIniReporte:'siscomer-datetime-inicio-report',
    storageDateFinReporte:'siscomer-datetime-fin-report',
    storageFilterTrabajo:'siscomer-filter-work',
    MessageErrorServer:'Error en el Servidor,ERROR_CONNECTION ',
    cantidadFotosTamañoMaximo:1000,
    aplicationVersion:'Siscomer Web v2.16.213',
}
export default config;
